import  gql  from 'graphql-tag'

export const catalogSalePercents = gql`query catalogSalePercents{ 
    catalogSalePercents{
        edges{
            node{
                id
                percent
            }
        }
    }
}`;
